import { ProductAdvancedSettingsBuilder } from "../builders";
import { CustomPurchaseWindow } from "./custom-purchase-window";
import { CustomRedeemWindow } from "./custom-redeem-window";

export class ProductAdvancedSettings {
  public readonly visibleDaysBeforeEvent: number;
  public readonly purchaseWindow: CustomPurchaseWindow;
  public readonly redeemWindow: CustomRedeemWindow;
  constructor(builder: ProductAdvancedSettingsBuilder) {
    this.visibleDaysBeforeEvent = builder.visibleDaysBeforeEvent;
    this.purchaseWindow = builder.purchaseWindow;
    this.redeemWindow = builder.redeemWindow;
  }

  toJSON() {
    return {
      visibleDaysBeforeEvent: this.visibleDaysBeforeEvent
        ? this.visibleDaysBeforeEvent
        : null,
      purchaseWindow: this.purchaseWindow ? this.purchaseWindow.toJSON() : null,
      redeemWindow: this.redeemWindow ? this.redeemWindow.toJSON() : null
    };
  }
}
